import { Card, CardActions, CardContent, Grid, Modal, Typography } from "@material-ui/core";
import { DELIVERY_TYPES, EXPRESS_TYPES, STATUS, SWITCH_STATUS } from "../../../config/constants";
import PrimaryButton from "../../common/PrimaryButton/PrimaryButton";
import { ServiceTypeBasicDetails } from "../CountrySettingView";
import { ConfigInterface, COUNTRY_SETTING_TEXT_CONSTANT, getHolidaysListObject, ServiceConfigInterface } from "../CountrySettingsUtils";
import { isArrayValid, isNonEmptyObject, isUndefined } from "../../../utils/DataUtils";

interface CountryChangesConfirmationModalProps {
  open: boolean;
  onClose: () => void;
  classes: any;
  loading: boolean;
  handleSubmit: () => void;
  config: ConfigInterface;
}

export const CountryChangesConfirmationModal = (props: CountryChangesConfirmationModalProps) => {
  const { open, onClose, classes, loading, handleSubmit, config } = props;

  const getHolidayList = (holidays: any) => {
    if (!isUndefined(holidays) && isArrayValid(holidays)) {
      let allHolidays: string[] = [];
      for (const holiday of holidays) {
        if (holiday.dateLabel) {
          const list = getHolidaysListObject(holiday);
          allHolidays = [...allHolidays, ...list.map((item: { objectDate: any }) => item.objectDate)];
        } else if (!isUndefined(holiday.offDate)) {
          allHolidays.push(holiday.offDate);
        }
      }
      return allHolidays.join(", ");
    }
    return "";
  };

  const renderServiceTypeDetails = (serviceTypeName: string, details: ServiceConfigInterface, deliveryType: string) => {

    const getExpressTypeStatus = () => {
      if (details.deliveryType === DELIVERY_TYPES.MINUTE_BASED && COUNTRY_SETTING_TEXT_CONSTANT.KEY_EXPRESS_TYPE in details) {
        const detailsWithExpressType = details as ServiceConfigInterface & { expressType: string };
        if (detailsWithExpressType.expressType === EXPRESS_TYPES.SLOT_BASED.value) {
          return EXPRESS_TYPES.SLOT_BASED.label;
        } else if (detailsWithExpressType.expressType === EXPRESS_TYPES.ON_DEMAND.value) {
          return EXPRESS_TYPES.ON_DEMAND.label;
        }
      }
      return undefined;
    };

    return (
      <Grid item xs={4} className={classes.serviceTypeGridItem}>
        <Grid container spacing={0} justifyContent="flex-start" className={classes.serviceTypeGridContainer}>
          <ServiceTypeBasicDetails
            classes={classes}
            serviceTypeName={serviceTypeName}
            serviceActiveStatus={details.serviceActive ? STATUS.ACTIVE : STATUS.IN_ACTIVE}
            nextDaySlotVisibilityStatus={details.nextDaySlotVisibility ? SWITCH_STATUS.ON : SWITCH_STATUS.OFF}
            editSlotDaysStatus={details.editSlotDays}
            advanceSlotDays={details.advanceSlotDays}
            plasticBagChargeStatus={details.bagChargeEnabled ? STATUS.ENABLED : STATUS.DISABLED}
            expressTypeStatus={getExpressTypeStatus()}
            itemsPerBag={details.itemsPerBag}
            bagCharges={details.bagCharges}
            newPlasticBagCharges={details.newPlasticBagCharges}
          />
          {deliveryType === DELIVERY_TYPES.DAY_BASED &&
            COUNTRY_SETTING_TEXT_CONSTANT.KEY_HOLIDAYS in details &&
            COUNTRY_SETTING_TEXT_CONSTANT.KEY_WEEKLY_HOLIDAYS in details && (
              <>
                <Grid item xs={12} className={classes.serviceTypeDetailsGridItem}>
                  <Typography className={classes.applyModalBodyContent}>{`${COUNTRY_SETTING_TEXT_CONSTANT.CALENDAR_HOLIDAYS} : `}</Typography>
                  <Typography className={classes.selectedValuesData}>{getHolidayList((details as { holidays: string[] }).holidays)}</Typography>
                </Grid>
                <Grid item xs={12} className={classes.serviceTypeDetailsGridItem}>
                  <Typography className={classes.applyModalBodyContent}>{`${COUNTRY_SETTING_TEXT_CONSTANT.WEEKLY_HOLIDAYS} : `}</Typography>
                  <Typography className={classes.selectedValuesData}>{`${(details as { weeklyHolidays: string[] }).weeklyHolidays?.join(", ")}`}</Typography>
                </Grid>
              </>
            )
          }
        </Grid>
      </Grid>
    );
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Card className={classes.applyChangesModalBody}>
        <CardContent>
          <Grid item xs={12} className={classes.modalTitleGridItem}>
            <Typography className={classes.modalTitle}>{`${COUNTRY_SETTING_TEXT_CONSTANT.CONFIRM_CHANGES}`}</Typography>
          </Grid>
          <Grid container spacing={0} className={classes.modalBody}>
            {isNonEmptyObject(config) && Object.keys(config).map((serviceTypeName) =>
              renderServiceTypeDetails(
                serviceTypeName,
                config[serviceTypeName],
                config[serviceTypeName].deliveryType
              )
            )}
          </Grid>
        </CardContent>
        <CardActions className={classes.serviceTypeFooterGridItem}>
          <Grid container spacing={2} justifyContent="flex-end">
            <Grid item>
              <PrimaryButton
                className={classes.buttonStyles}
                buttonLabel={COUNTRY_SETTING_TEXT_CONSTANT.CANCEL}
                buttonVariant="outlined"
                onClick={onClose}
              />
            </Grid>
            <Grid item>
              <PrimaryButton
                className={classes.buttonStyles}
                buttonLabel={loading ? COUNTRY_SETTING_TEXT_CONSTANT.IS_LOADING : COUNTRY_SETTING_TEXT_CONSTANT.PROCEED}
                onClick={handleSubmit}
                disabled={loading}
              />
            </Grid>
          </Grid>
        </CardActions>
      </Card>
    </Modal>
  );
};
